import { Link } from 'react-router-dom';
import { listTools } from '@/lib/tools';
import { useLang, useLangHref, useT } from '@/lib/useLang';

export function ToolsIndex() {
  const t = useT();
  const lang = useLang();
  const withLang = useLangHref();
  const tools = listTools(lang);

  return (
    <section className="nz-page">
      <div className="nz-eyebrow">{t.navTools}</div>
      <h1 className="nz-page__title">{t.toolsPageTitle}</h1>
      <p className="nz-lead">{t.toolsPageIntro}</p>

      {tools.length === 0 ? (
        <p className="nz-page__empty">{t.toolsEmpty}</p>
      ) : (
        <div className="nz-tools-grid">
          {tools.map((tool) => (
            <Link className="nz-tool-card" key={tool.slug} to={withLang(`/tools/${tool.slug}`)}>
              <h2 className="nz-tool-card__title">{tool.title}</h2>
              <p className="nz-tool-card__desc">{tool.valueLine}</p>
              <span className="nz-tool-card__more" aria-hidden="true">
                {t.toolsTry} →
              </span>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
